var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-stars"},_vm._l((5),function(star){return _c('StarIcon',{key:star,staticClass:"rating-stars__star-icon",class:{
      'rating-stars__star-icon--hover': !_vm.readOnly && star <= _vm.hover,
      'rating-stars__star-icon--selected': star <= _vm.value,
    },on:{"click":function($event){return _vm.handleRatingSelected(star)},"mouseover":function($event){return _vm.setHover(star)},"mouseleave":function($event){return _vm.setHover(0)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }